export enum FeatureEntitlements {
  ScanAndPayRetailers = 'scan_and_pay_retailers',
  PartnerBulkDeliveryEnabled = 'fulfillment.delivery_software.partner_bulk_delivery_enabled',
}
